if (typeof console == "undefined" || typeof console.log == "undefined") var console = { log: function() {} };

$(function()
{
	IV.init();
});

var IVUser =
{
    constIGNORE: "ignore",
    constSUBSCRIBES: "subscribes",
    constWATCHLATER: "watchlater",
    cLiveBackPressed: "live_back_pressed",
	cSubscribe_opened: "subscribe_opened",
    cSubscribeNumClicked: "subscribeNumClicked",
	cWatchlater_opened: "watchlater_opened",
    htmlOverlayIgnore: "<div class='opacityLayer85white i'><div>Ezt a videót töröltük a listáról.<br><span>törlés visszavonása</span></div></div>",
    htmlOverlayWatchlater: "<div class='opacityLayer85white wl'><div>ezt a videót eltetted későbbre.<br><span>mégsem</span></div></div>",
    intervalAnimateSubscribeIcon: 0,
    intervalGetNew: 0,
    iSubscribeLoadImage: '',
    oScroller: {},
    oScrollerWatchLater: {},
    page: "mainpage",
    sCheckboxes: '#subscribes_header input[type=checkbox]',
    sCSRF: '#csrf',
    sCSRFSubscription: '#CSRF_subscription',
    sCSRFProfil: '#CSRF_videoBox',
    sCSRFBroadcast: '#CSRF_broadcast',
    sCustomData: '#customdata',
    sDigestFreqRadio: '.digest_freq_radio',
    sIgnoreVideoBtn: ".edit_watchlater_button",
    sGetNewText: "Új videók kerültek kedvenc csatornáidra!",
    sHeaderSubscriberNum: '#us_subs',
    sIndafotoErotikaKep: "#indafoto-erotika-box .indafoto-erotika-box-image",
    sIndafotoErotikaKepCim: "#indafoto-erotika-box .indafoto-erotika-box-image-title",
    sIndafotoErotikaKepAuthor: "#indafoto-erotika-box .indafoto-erotika-box-image-author",
    sIranyito: '#iranyito',
    sIranyitoExit: '#iranyito .exit',
    sIranyitoNext: '#iranyito .next',
    sIranyitoPrev: '#iranyito .prev',
    sLazy: ".lazy",
    sLiveDownBtn: ".live_down .btn",
    sLogoutSubscribeBtn: '.loggedout_subscribe_btn',
    sManageSubscribe: '#subscribes li .leiratkoz',
    sMegnezemBtn: "#tv .btn",
    sMKSPromo: "#mks_banner",
    sMyContainer: '#my_container',
    sMySubscribtions: '#my_subscribes',
    sMyWatchLater: '#my_watch_later',
    sOverlayLayerName: "opacityLayer85white",
    sPlaylistSubscribe: '.playlist_subscribe',
    sPromoClose: '.promo_hover .close',
    sPromoHoverElement: '.promo_hover',
    sRestoreIgnoreVideos: '.opacityLayer85white.i div span',
    sRestoreWatchlaterVideos: '.opacityLayer85white.wl div span',
    sSubscribedElements: '#my_subscribed_videos_elements',
    sWatchlaterElements: '#my_watchlater_videos_elements',
    sSubscribedVideo: '#my_subscribed_videos_elements li a',
    sWatchlaterVideo: '#my_watchlater_videos_elements li a',
    sSubscribeLi: '#subscribes li',
    sSubscribeLoadImageSrc: '/images/default/icons2/feliratkozas_loading.gif',
    sSubscriber: '.playlist_subscribe',
    sSubscriberIcon: '.playlist_subscribe .ps .img',
    sSubscriberNum: '.playlist_subscribe_num',
    sSubscribesList: '#my_subscribed_videos',
    sSubscribesListOpener : '#channelBar .back .subscribes_open',
    sSubscribesInner: "#my_subscribed_videos_inner",
    sVideo: "#video404",
    sVideoSource: "#video404 source",
    sWatchLater: ".add_watch_later",
    sWatchLaterBtn: '.watchlater_button',
    sWatchLaterInner: "#my_watchlater_videos_inner",
    sWatchLaterList: '#my_watchlater_videos',
    sWatchLaterSubscriber: ".new_browse .subscribe_button",

    sSubscribeEdit : ".subscribe_edit",
    sNewVideosCount: "#new_videos_count",

    urlUserHandler: '/userhandler',
    urlVideoHandler: '/videohandler',

    videos404: [],
    videos404data: {},

    cookieMKSPromo: "mks_promo",

    init: function()
    {
    	var self = this;

    	if ($.cookie(self.cookieMKSPromo) == "1")
    		$(self.sMKSPromo).hide();
        
        this.sSubscribeLoadImageSrc = IV.assetsUrl + this.sSubscribeLoadImageSrc;

        if ($(this.sSubscribesList).length !== 0) {
            this.oScroller = new Scroller();
            this.oScrollerWatchLater = new Scroller({
                personalContexts : "#my_watchlater_videos",
                leftArrowElem : "#my_watchlater_videos .left.arrow",
                rightArrowElem : "#my_watchlater_videos .right.arrow",
                sliderContainer : "#my_watchlater_videos_elements"
            });
        }

        $(this.sSubscribedElements).find(this.sLazy).each(function() {
        	$(this).lazyload({
        		event: "lazyload",
        		effect: "fadeIn",
		    	container: $(self.sSubscribedElements)
			}).trigger("lazyload");
		});

		$(this.sWatchlaterElements).find(this.sLazy).each(function() {
        	$(this).lazyload({
        		event: "lazyload",
        		effect: "fadeIn",
		    	container: $(self.sWatchlaterElements)
			}).trigger("lazyload");
		});

        this.iSubscribeLoadImage = new Image();
        this.iSubscribeLoadImage.src = this.sSubscribeLoadImageSrc;
        this.events();

        if (getUrlParam("error") == "badpass" && getUrlParam("error_from") == "subscribe")
            $(this.sLogoutSubscribeBtn).click();

        this.getPageType();
        var location = window.location;

        // if ($.cookie(IVUser.cSubscribe_opened) && !/http\:\/\/film\.[a-zA-Z\.\-]*indavideo\.hu/.test(location) && !/http\:\/\/palyazat\.[a-zA-Z\.\-]*indavideo\.hu/.test(location)) {
        //  this.toggleSubscribes();
        // }
        // this.getNewSubscribedVideos();
    },

    ePromoHoverCloseClick: function()
	{
		var mom = IVUser;
        var hash = $(mom.sPromoHoverElement).data('hash');

        if (hash == "")
            hash = mom.cookieMKSPromo;

		$(mom.sMKSPromo + ', ' + mom.sPromoHoverElement).hide();

		$.cookie(hash, '1', { expires: 1, path: '/' } );
	},

    animateSubscribe: function(stop) {
        var mom = this;

        stop = (stop === undefined || !stop) ? false : true;

        if (!$(mom.sSubscriber).hasClass("loading") && mom.intervalAnimateSubscribeIcon === 0 && !stop) {
            $(mom.sSubscriberIcon).fadeOut(600, function() {
                // $(mom.sSubscriber).animate({
                //  background: "rgb(208,88,76)"
                // },1000, function() {
                // });

                $(this).fadeIn(600, function() {
                    $(mom.sSubscriberIcon).css({ 'background-position': "-198px -22px" });
                    setTimeout(function() {
                        $(mom.sSubscriberIcon).css({ 'background-position': "-198px 0" });
                    },500);

                    setTimeout(function() {
                        $(mom.sSubscriberIcon).css({ 'background-position': "-198px -22px" });
                    },1000);

                    setTimeout(function() {
                        $(mom.sSubscriberIcon).css({ 'background-position': "-198px 0" });
                    },1500);

                    setTimeout(function() {
                        $(mom.sSubscriberIcon).css({ 'background-position': "-198px -22px" });
                    },2000);

                    setTimeout(function() {
                        $(mom.sSubscriberIcon).css({ 'background-position': "-198px 0" });
                    },2500);
                });
            });

            mom.intervalAnimateSubscribeIcon = setInterval(function() {
                $(mom.sSubscriberIcon).fadeOut(600, function() {
                    $(mom.sSubscriber).animate({
                        background: "rgb(208,88,76)"
                    },500);
                    $(this).fadeIn(600, function() {
                        $(mom.sSubscriberIcon).css({ 'background-position': "-198px -22px" });
                        setTimeout(function() {
                            $(mom.sSubscriberIcon).css({ 'background-position': "-198px 0" });
                        },500);

                        setTimeout(function() {
                            $(mom.sSubscriberIcon).css({ 'background-position': "-198px -22px" });
                        },1000);

                        setTimeout(function() {
                            $(mom.sSubscriberIcon).css({ 'background-position': "-198px 0" });
                        },1500);

                        setTimeout(function() {
                            $(mom.sSubscriberIcon).css({ 'background-position': "-198px -22px" });
                        },2000);

                        setTimeout(function() {
                            $(mom.sSubscriberIcon).css({ 'background-position': "-198px 0" });
                        },2500);
                    });
                });
            },4400);
            setTimeout(function() {
                $(mom.sSubscriber).addClass('loading');
            },600);
        }
        else if (stop || $(mom.sSubscriberIcon).closest('.ps').is(":visible")) {
            if (mom.intervalAnimateSubscribeIcon !== 0)
                clearInterval(mom.intervalAnimateSubscribeIcon);
            mom.intervalAnimateSubscribeIcon = 0;
            $(mom.sSubscriber).removeClass('loading');
            $(mom.sSubscriberIcon).stop(true).removeAttr('style');
        }
    },

    events: function()
    {
        $(document).on("click",this.sDigestFreqRadio,this.eDigestClick);
        $(document).on("click",this.sManageSubscribe,this.eManageSubscribeClick);
        $(document).on("click",this.sWatchLaterSubscriber,this.eSubscribeClick);
        $(document).on("click",this.sPlaylistSubscribe,this.eSubscribeClick);
        $(document).on("click",this.sSubscribesListOpener,this.eSubscribesListOpen);
        $(document).on("click",this.sMySubscribtions,this.eSubscribesListOpen);
        $(document).on("click",this.sMyWatchLater,this.eWatchLaterListOpen);
        $(document).on("click",this.sNewVideosCount,this.eSubscribesListOpen);
        $(document).on("click",this.sSubscribedVideo,this.eSubscribeVideoClick);
        $(document).on("click",this.sWatchlaterVideo,this.eWatchlaterVideoClick);

        $(document).on("click",this.sLiveDownBtn,this.eLiveDownBtnClick);

        $(document).on("click",this.sWatchLater,this.eSetWatchLater);
        $(document).on("click",this.sWatchLaterBtn,this.eSetWatchLater);

        $(this.sLogoutSubscribeBtn).on("click",this.eLoginAndSubscribe);
        $(document).on("click",this.sIgnoreVideoBtn,this.eIgnoreVideo);
        $(document).on("click",this.sRestoreIgnoreVideos,this.eRestoreIgnoreVideo);
        $(document).on("click",this.sRestoreWatchlaterVideos,this.eRestoreWatchlaterVideo);
        $(document).on("change",this.sCheckboxes,this.eCheckAll);

        $(document).on('click',this.sPromoClose,this.ePromoHoverCloseClick);

        $(this.sIranyitoExit)
                    .on("mousedown",this.ePushIranyitoBtn)
                    .on("mouseup",this.eReleaseIranyitoBtn);
        $(this.sIranyitoNext)
                    .on("click",this.eRefresh404Video)
                    .on("mousedown",this.ePushIranyitoBtn)
                    .on("mouseup",this.eReleaseIranyitoBtn);
        $(this.sIranyitoPrev)
                    .on("click",this.eRefresh404Video)
                    .on("mousedown",this.ePushIranyitoBtn)
                    .on("mouseup",this.eReleaseIranyitoBtn);

        $(document).on("click",this.sIndafotoErotikaKep,function() {
			_gaq.push(['t2._trackEvent', 'Indafotó', 'Erotika doboz - ' + IVUser.page, "kép"]);
        });
        $(document).on("click",this.sIndafotoErotikaKepCim,function() {
			_gaq.push(['t2._trackEvent', 'Indafotó', 'Erotika doboz - ' + IVUser.page, "kép címe"]);
        });
        $(document).on("click",this.sIndafotoErotikaKepAuthor,function() {
			_gaq.push(['t2._trackEvent', 'Indafotó', 'Erotika doboz - ' + IVUser.page, "kép készítője"]);
        });
    },

    eCheckAll: function(e)
    {
        var c = $(e.target).closest("span").attr('class');
        $(IVUser.sCheckboxes).attr("checked",false);
        $("."+c+" input").attr('checked', true);

        var ids = [];
        var user = "";
        var freq = "";
        $("."+c+" input[type=radio]").each(function() {
            ids.push($(this).attr('data-id'));
            if (user === "")
                user = $(this).attr("data-user");
            if (freq === "")
                freq = $(this).attr("data-digest");
        });

        IVUser.subscribe(user,1,{digest_frequency:freq, ids:ids});
        // ide kell gomb-refresh

        return false;
    },

    eIgnoreVideo : function(e) {
        IVUser.ignoreVideo($(this).attr("data-videourltitle"),{target: e.target});
    },

    eDigestClick : function()
    {
        IVUser.subscribe($(this).attr("data-user"),1, {digest_frequency: $(this).attr("data-digest")});
        $(IVUser.sCheckboxes).attr("checked",false);

        // return false;
    },

    eLiveDownBtnClick: function(e) {
    	var self = IVUser;

    	var user = $(self.sLiveDownBtn).data("name");
    	if (!$(self.sLiveDownBtn).hasClass('done') && !$(self.sLiveDownBtn).hasClass('loading') && $.cookie(self.cLiveBackPressed) != 1) {
	    	$(self.sLiveDownBtn).addClass("loading");

	    	$.ajax({
	            url : self.urlUserHandler + "/" + user,
	            type : "POST",
	            data : {
	            	op: "broadcastBack",
	                CSRF: $(self.sCSRFBroadcast).val()
	            },
	            dataType : "json",
	            success : function(data) {
	                $(self.sLiveDownBtn).removeClass('loading').html("Köszönjük!").addClass("done");
	                $.cookie(IVUser.cLiveBackPressed, 1, { expires: 365, path: '/', domain: 'indavideo.hu' });
	            }
	        });
	    }
    },

    eLoginAndSubscribe: function(e) {
        IV.prevent(e);
        var location = window.location.href;
        var domain = location.split("/")[2];

        var redirUrl = "http://"+domain+"/userhandler/"+$(e.target).closest(IVUser.sSubscriber).attr("data-user")+"?addOrRemove=1&digest_frequency=10&op=subscribe&login_name="+$(e.target).closest(IVUser.sSubscriber).attr("data-user")+"&CSRF="+$(IVUser.sCSRFSubscription).val()+"&redirect_to="+encodeURIComponent(location);
        msgLogin(false,redirUrl);
    },

    eManageSubscribeClick: function(e)
    {
        IV.prevent(e);

        if (!$(e.target).hasClass('loggedout_subscribe_btn'))
            IVUser.subscribe($(this).attr("data-user"),0, {digest_frequency: 10});
        $(this).closest('li').remove();

        if ($(IVUser.sSubscribeLi).length < 2) {
            $(IVUser.sCustomData).html('<div id="null-subscriber">Nincs még feliratkozásod!</div>');
        }

        return false;
    },

    ePushIranyitoBtn: function(e) {
        var self = IVUser;

        $(e.target).addClass("clicked");
        $(self.sIranyito).addClass("clicked");
    },

    eReleaseIranyitoBtn: function(e) {
        var self = IVUser;

        $(e.target).removeClass("clicked");
        $(self.sIranyito+","+self.sIranyitoPrev+","+self.sIranyitoNext).removeClass("clicked");
    },

    eRefresh404Video: function(e) {
        var self = IVUser;
        var irany = "";
        var video = $(self.sVideo);
        var videoSource = $(self.sVideoSource);
        var videoDOM = $(self.sVideo)[0];
        var originalURL = videoSource.attr("src");
        var originalPoster = video.attr("poster");

        if ($(e.target).hasClass("prev"))
            irany = "vissza";
        else if ($(e.target).hasClass('next'))
            irany = "elore";

        var array = {
            tmb_src : originalPoster,
            url : $(IVUser.sMegnezemBtn).attr("href")
        };

        if ($.inArray(originalURL, IVUser.videos404) < 0) {
            self.videos404.push(originalURL);
            self.videos404data[originalURL] = array;
        }

        if (irany == "elore") {
            if ($.inArray(originalURL, IVUser.videos404) == IVUser.videos404.length-1) {
                $.ajax({
                    url : "/404",
                    type : "POST",
                    data : {
                        "ajax" : 1
                    },
                    dataType : "json",
                    success : function(data) {
                        if (data.video_hash && data.video_hash != "") {
                            var src = originalURL.replace(/\/404\/[a-z0-9]+\.mp4/g,"/404/"+data.video_hash+".mp4");
                            var poster = originalPoster.replace(/indavideo\.hu\/videos\/[0-9\/\\\-]+\.jpg/g,"indavideo.hu/videos/"+data.tmb_src);

                            $(IVUser.sMegnezemBtn).attr("href","/video/"+data.url_title);
                            video.attr("poster",poster);
                            videoDOM.setAttribute("src", src);
                            videoSource.attr("src", src);
                            videoDOM.load();
                        }
                    }
                });
            }
            else {
                var next = IVUser.videos404[($.inArray(originalURL, IVUser.videos404)+1)];

                $(IVUser.sMegnezemBtn).attr("href",IVUser.videos404data[next]["url"]);
                video.attr("poster",IVUser.videos404data[next]["tmb_src"]);
                videoDOM.setAttribute("src", next);
                videoSource.attr("src", next);
                videoDOM.load();
            }
        }
        else if (irany == "vissza" && $.inArray(originalURL, IVUser.videos404) != 0) {
            var before = IVUser.videos404[($.inArray(originalURL, IVUser.videos404)-1)];

            $(IVUser.sMegnezemBtn).attr("href",IVUser.videos404data[before]["url"]);
            video.attr("poster",IVUser.videos404data[before]["tmb_src"]);
            videoDOM.setAttribute("src", before);
            videoSource.attr("src", before);
            videoDOM.load();
        }
    },

    eRestoreIgnoreVideo: function(e) {
        IV.prevent(e);

        var item = $(e.target).closest(".item");
        if (item.length > 0)
            IVUser.restoreIgnoreVideo(item);
    },

    eRestoreWatchlaterVideo: function(e) {
        IV.prevent(e);

        var item = $(e.target).closest(".item");
        if (item.length > 0)
            IVUser.restoreWatchlaterVideo(item);
    },

	eSetWatchLater: function(e)
    {
		IV.prevent(e);
        // console.log("wl");
        var url_title = $(e.target).attr("data-title");
        var addremove = 1;

        if ($(e.target).hasClass('later'))
            addremove = 0;

        IVUser.watchlater(url_title, addremove, { target: e.target });

        var elements = $(e.target).closest(IVUser.sSubscribedElements);

        if (elements.length > 0) {
            $(e.target).closest('li').fadeOut('fast').remove();
            IVUser.oScroller.refreshSlider();

            if (elements.find("li").length === 0)
                IVUser.getSubscribedVideos();
        }

	},

	eSubscribeClick: function(e)
	{
        IV.prevent(e);

        if (!$(e.target).hasClass('loggedout_subscribe_btn') && $(e.target).closest(".loggedout_subscribe_btn").length === 0) {
            var confirm = ($(e.target).closest(".TYPE_47").length > 0 && $(e.target).hasClass('subscribed')) ? 1 : 0;
            IVUser.subscribe($(this).attr("data-user"),(($(e.target).hasClass("subscribed") || $(e.target).hasClass("p_sdl")) ? 0 : 1), {digest_frequency: 10, target: e.target, confirm: confirm});
        }

		return false;
	},

	eSubscribesListOpen: function(e)
	{
		// IVUser.getSubscribedVideos();
        IV.prevent(e);
		IVUser.toggleSubscribes(true);
		//IVUser.clearGetNew();

		return false;
	},

	eSubscribeVideoClick: function() {
		_gaq.push(['t2._trackEvent', 'Subscribe', 'SubsBarVideo', IVUser.page]);
	},

    eWatchlaterVideoClick: function() {
        _gaq.push(['t2._trackEvent', 'Watchlater', 'WatchlBarVideo', IVUser.page]);
    },

	// clearGetNew: function(allclear)
	// {
	// 	clearInterval(IVUser.intervalGetNew);
	// 	$(IVUser.sNewVideosCount).animate({
	// 		left: "350px"
	// 	},{
	// 		queue: false,
	// 		duration: 200
	// 	});

	// 	$(IVUser.sMySubscribtions).animate({
	// 		left: "-30px"
	// 	}, {
	// 		queue: false,
	// 		duration: 400,
	// 		easing: "easeOutCirc",
	// 		complete: function() {
	// 			$(IVUser.sMySubscribtions).text("Feliratkozásaim").css({
	// 				color: "#191919"
	// 			}).removeClass("got_new").animate({
	// 				left: "0px"
	// 			}, {
	// 				queue: false,
	// 				duration: 400,
	// 				easing: "easeOutCirc"
	// 			}).animate({
	// 				opacity: 1
	// 			}, 200, "linear");
	// 		}
	// 	}).animate({
	// 		opacity: 0
	// 	}, 200, "linear");

	// 	if (!allclear)
	// 		IVUser.intervalGetNew = setInterval(IVUser.getNewSubscribedVideos, 5000);
	// },

	// getNewSubscribedVideos: function()
	// {
	// 	if($(IVUser.sSubscribesList).hasClass('opened')) {
	// 		var rand = Math.floor((Math.random()*5)+1);
	// 		console.log(rand);

	// 		if ($(IVUser.sNewVideosCount).css("left") == "320px")
	// 			$(IVUser.sNewVideosCount).animate({
	// 				left: "350px"
	// 			}, 200, "linear", function() {
	// 				console.log("kimegy");
	// 			});

	// 		$(IVUser.sNewVideosCount).animate({
	// 			left: "320px"
	// 		},200,"linear",function() {
	// 			$(this).text(rand);
	// 			console.log("bejön");
	// 		});

	// 		var li = $(IVUser.oScroller.sliderContainer+" li").first();

	// 		for (var i = 0; i<rand; i++) {
	// 			$(IVUser.oScroller.sliderContainer).prepend(li.clone().addClass('hidden_li'));
	// 		}

	// 		$(IVUser.oScroller.sliderContainer+" li.hidden_li").animate({
	// 			opacity: 1
	// 		},1000,"easeInCirc",function() {
	// 			$(this).removeClass("hidden_li");
	// 		});


	// 		if ($(IVUser.oScroller.sliderContainer).css("marginLeft") != "0px") {
	// 			IVUser.oScroller.visibleFirst += rand;
	// 			IVUser.oScroller.sliderMargin -= IVUser.oScroller.oneLi*rand;
	// 			IVUser.clearGetNew(true);
	// 			console.log("nincs elöl");
	// 		}

	// 		IVUser.oScroller.refreshSlider();
	// 	}
	// 	else {
	// 		IVUser.setGetNew();
	// 	}
	// },

	eWatchLaterListOpen: function()
	{
		// IVUser.getSubscribedVideos();
		IVUser.toggleSubscribes(true,true);
		//IVUser.clearGetNew();

		return false;
	},

	addOpacityLayerToElement : function(element,type) {
        var mom = IVUser;

		if (!(element instanceof jQuery))
			element = $(element);

        if (!(element instanceof jQuery) || element.length == 0)
            console.log("nincs ilyen elem a DOMban");

        if (type == mom.constWATCHLATER)
            element.append(mom.htmlOverlayWatchlater);
        else if (type == mom.constIGNORE)
            element.append(mom.htmlOverlayIgnore);

        element.find("."+mom.sOverlayLayerName).animate({
            opacity: 1
        },"slow");
		element.addClass('deleted');

	},

	getPageType: function() {
		var loc = window.location.href;

		if (/\/browse/.test(loc)) {
			this.page = "browse";
		}
		else if (/\/video/.test(loc)) {
			this.page = "video";
		}
		else if (/\/profile/.test(loc)) {
			this.page = "profile";
		}
		else if (/\/upload/.test(loc)) {
			this.page = "upload";
		}
		else if (/\/broadcast/.test(loc)) {
			this.page = "broadcast";
		}
	},

	getSubscribedVideos: function() {
		$.ajax(
		{
			url: this.urlVideoHandler,
			type: 'POST',
			dataType: 'json',
			data:
			{
				op: 'getSubscribedContent'
			},
			success: function(res)
			{
				if (res.success == 1) {
					if (res.videos.length != 0) {
						var out = "";
						$.each(res.videos, function(index,item) {
							out += '<li>' +
								'<div class="video_image">' +
									'<span class="add_watch_later" data-title="'+item.url_title+'"></span>' +
									'<a href="'+item._urlVideo+'">' +
										'<img src="'+item._urlpicVideo+'">' +
									'</a>' +
								'</div>' +
								'<span class="my_subscribed_videos_data">' +
									'<h3><a href="'+item._urlVideo+'">'+item.title+'</a></h3>' +
									'<a href="'+item._urlProfile+'" class="my_subscribed_video_owner">' +
										'<img class="my_subscribed_video_owner_pic" src="'+item._urlpicAvatar+'">' +
										(item.username !== "" ? item.username : item.login_name)+
									'</a>' +
								'</span>' +
								'<div class="clear"></div>' +
							'</li>';
						});

						$(IVUser.sSubscribedElements).html(out);
						IVUser.oScroller.refreshSlider();
					}
					else{
						$(IVUser.sSubscribedElements).html("<li>Nincs megnézendő videód!</li>")
						IVUser.oScroller.refreshSlider();
						IVUser.toggleSubscribes();
					}
				}
			},
			error: function(xhr)
			{
				console.log("rossz",xhr);
			} //function
		});
	},

    ignoreVideo : function(video_url_title,D) {
        $(D.target).addClass('pulsing');

        $.ajax(
        {
            url: this.urlVideoHandler,
            type: 'POST',
            dataType: 'json',
            data:
            {
                op: 'setIgnore',
                url_title: video_url_title,
                remove: (D.remove) ? 1 : 0
            },
            success: function(res)
            {
                if (!D.remove && D.target) {
                    var target = (D.target instanceof jQuery) ? D.target : $(D.target);
                    var item = (target.hasClass('item')) ? target : target.closest('.item');

                    IVUser.addOpacityLayerToElement(item,IVUser.constIGNORE);
                    $(D.target).removeClass('pulsing');
                }
                else if (D.target) {
                    var target = (D.target instanceof jQuery) ? D.target : $(D.target);
                    var item = (target.hasClass('item')) ? target : target.closest('.item');

                    IVUser.removeOpacityLayer(item);
                }
            }
        });
    },

	isSubscribed: function(user)
	{
		var mom = this;

		$.ajax(
		{
			url: this.urlUserHandler + user,
			type: 'POST',
			dataType: 'json',
			data:
			{
				op: 'subscribed'
			},
			success: function(res)
			{
				if (res.success == 1)
					$(IVUser.sSubscriber).addClass("subscribed");
			} //function
		});
	},

	// setGetNew: function()
	// {
	// 	IVUser.intervalGetNew = setInterval(function() {
	// 		if ($(IVUser.sNewVideosCount).css("left") == "320px")
	// 			$(IVUser.sNewVideosCount).animate({
	// 				left: "350px"
	// 			}, 200, "linear");

	// 		$(IVUser.sNewVideosCount).text(Math.floor((Math.random()*100)+1)).animate({
	// 			left: "320px"
	// 		},200,"linear",function() {
	// 			$(IVUser.sMySubscribtions).animate({
	// 				left: "-30px"
	// 			}, {
	// 				queue: false,
	// 				duration: 400,
	// 				easing: "easeOutCirc",
	// 				complete: function() {
	// 					if ($(IVUser.sMySubscribtions).text() != IVUser.sGetNewText)
	// 						$(IVUser.sMySubscribtions).text(IVUser.sGetNewText);

	// 					$(IVUser.sMySubscribtions).css({
	// 						color: "#bd1818"
	// 					});

	// 					$(IVUser.sMySubscribtions).addClass("got_new").animate({
	// 						left: "0px"
	// 					}, {
	// 						queue: false,
	// 						duration: 400,
	// 						easing: "easeOutCirc"
	// 					}).animate({
	// 						opacity: 1
	// 					}, 200, "linear");
	// 				}
	// 			}).animate({
	// 				opacity: 0
	// 			}, 200, "linear");
	// 		});
	// 	}, 4000);
	// },

    removeOpacityLayer : function(item) {
        if (!(item instanceof jQuery))
            item = $(item);

        item.find("."+IVUser.sOverlayLayerName).fadeOut('slow', function() {
            $(this).remove();
            item.removeClass('deleted');
        });
    },

    restoreIgnoreVideo : function(item) {
        if (!(item instanceof jQuery))
            item = $(item);

        var btn = item.find(IVUser.sIgnoreVideoBtn);
        if (btn.length > 0) {
            var url_title = btn.attr("data-videourltitle");

            IVUser.ignoreVideo(url_title,{'remove': 1, 'target': item});
        }
    },

    restoreWatchlaterVideo : function(item) {
        if (!(item instanceof jQuery))
            item = $(item);

        var btn = item.find(IVUser.sWatchLaterBtn);
        if (btn.length > 0) {
            var url_title = btn.attr("data-title");

            IVUser.watchlater(url_title,0,{target: item, removeLayer: 1});
        }
    },

	subscribe: function(user, addremove, D)
	{
		var mom = IVUser;
		if (addremove === 1)
			mom.animateSubscribe();
		// return;

        if (typeof user === "object" && Object.keys(user).length == 3) {
            addremove = (user.addremove) ? user.addremove : 0;
            D = user.D;
            user = user.user;
        }

        if ((!user || !addremove) && addremove != 0) {
			return false;
        }

		var ids = null;

		if (D.ids != undefined && D.ids)
			ids = D.ids.join();

		var url = (D.ids != undefined && D.ids) ? mom.urlUserHandler : mom.urlUserHandler + "/" + user;
		var type = (D.ids != undefined && D.ids) ? "GET" : "POST";

        var subscribers = parseInt($(mom.sSubscriberNum).first().text() != "" ? $(mom.sSubscriberNum).first().text() : 0);

        if (D.confirm) {
            D.confirm = 0;
            msgYesNo(
                "Tényleg leiratkozol a csatorna új videóiról?",
                "Még meggondolhatod magad!",
                1,
                {
                    doFunction : IVUser.subscribe,
                    args: {
                        user : user,
                        addremove : addremove,
                        D : D
                    }
                },
                false);
        }
        else {
    		$.ajax(
    		{
    			url: url,
    			type: type,
    			dataType: 'json',
    			data:
    			{
    				op: 'subscribe',
    				addOrRemove: addremove,
    				digest_frequency: D.digest_frequency,
    				uid: ids,
    				CSRF: $(mom.sCSRFSubscription).length > 0 ? $(mom.sCSRFSubscription).val() : $(mom.sCSRFProfil).val()
    			},
    			success: function(res)
    			{
    				mom.animateSubscribe(true);
    				if ($(IVUser.sSubscriber).hasClass('subscribed')) {
    					$(IVUser.sSubscriber).removeClass("subscribed");
    					$(IVUser.sSubscriberNum).text(subscribers-1);
    					$(IVUser.sHeaderSubscriberNum).text(subscribers-1);
    					if ((subscribers-1) == 0)
    						$(IVUser.sSubscriberNum).hide();
    				}
    				else {
    					$(IVUser.sSubscriber).addClass("subscribed");
    					$(IVUser.sSubscriberNum).show().text(subscribers+1);
    					$(IVUser.sHeaderSubscriberNum).text(subscribers+1);
    				}

    				if ($(D.target).hasClass("subscribe_button") && $(D.target).hasClass("non-subscribed") && $(D.target).closest('.watchlater').length > 0) {
                        var data_attr = $(D.target).attr("data-user");
                        $(".subscribe_button[data-user='"+data_attr+"']").fadeOut(200,function() {
                            $(this).hide();
                        });
                    }

                    if ($(D.target).hasClass("subscribe_button") && $(D.target).hasClass("subscribed")) {
                        var data_attr = $(D.target).attr("data-user");
                        $(".subscribe_button[data-user='"+data_attr+"']").removeClass('subscribed').addClass('non-subscribed').attr("title","Feliratkozás");
                    }
                    else {
                        var data_attr = $(D.target).attr("data-user");
                        $(".subscribe_button[data-user='"+data_attr+"']").removeClass('non-subscribed').addClass('subscribed').attr("title","Leiratkozás");
                    }

    			} //function
    		});
        }
	},

	toggleSubscribes: function(click,isWatchLater)
	{
		var mom = this;
		// if ($.cookie(IVUser.cWatchlater_opened)) {
		// 	$(mom.sSubscribesListOpener).toggleClass('opened');
		// }

		if (click) {
			if (isWatchLater) {
				if ($(mom.sSubscribesList).hasClass('opened')) {
                    if ($(IVUser.sSubscribeEdit).hasClass("active"))
                        $(IVUser.sSubscribeEdit).removeClass("active");

					$.removeCookie(IVUser.cSubscribe_opened, { path: '/', domain: 'indavideo.hu' });
					$.cookie(IVUser.cWatchlater_opened, 1, { expires: 365, path: '/', domain: 'indavideo.hu' });
					$(mom.sMyContainer).height($(mom.sMyContainer).height());
					$(mom.sMySubscribtions).removeClass('active');
					$(mom.sSubscribesList).fadeOut(300, function() {
						$(this).toggleClass('opened');
						$(mom.sWatchLaterList).fadeIn(300, function() {
							$(this).toggleClass('opened');
							$(mom.sMyWatchLater).toggleClass('active');
                            $(mom.sMyContainer).height("auto");
                        });
                    });
					_gaq.push(['t2._trackEvent', 'Watchlater', 'WatchlBarSwitch', this.page]);
                }
                else if ($.cookie(IVUser.cWatchlater_opened) == 1 && $(mom.sWatchLaterList).hasClass('opened')) {
                    if ($(IVUser.sSubscribeEdit).hasClass("active"))
                        $(IVUser.sSubscribeEdit).removeClass("active");

                    $.removeCookie(IVUser.cWatchlater_opened, { path: '/', domain: 'indavideo.hu' });
                    _gaq.push(['t2._trackEvent', 'Watchlater', 'WatchlBarClose', this.page]);
					$(mom.sWatchLaterList).slideToggle(200, function() {
						$(this).toggleClass('opened');
						$(mom.sMyWatchLater).toggleClass('active');
					});
				}
				else {
                    if ($(IVUser.sSubscribeEdit).hasClass("active"))
                        $(IVUser.sSubscribeEdit).removeClass("active");

					$.cookie(IVUser.cWatchlater_opened, 1, { expires: 365, path: '/', domain: 'indavideo.hu' });
					_gaq.push(['t2._trackEvent', 'Watchlater', 'WatchlBarOpen', this.page]);
					$(mom.sWatchLaterList).slideToggle(200, function() {
						$(this).toggleClass('opened');
						$(mom.sMyWatchLater).toggleClass('active');
					});
				}
				$(mom.sWatchlaterElements).find(mom.sLazy).trigger('lazyload');
			}
			else {
				if ($(mom.sWatchLaterList).hasClass('opened')) {
                    if ($(IVUser.sNewVideosCount).hasClass('active')) {
                        $(IVUser.sNewVideosCount).removeClass('active');
                        $.cookie(IVUser.cSubscribeNumClicked, 1, { expires: 1, path: '/', domain: 'indavideo.hu' });
                    }

                    if (!$(IVUser.sSubscribeEdit).hasClass("active"))
                        $(IVUser.sSubscribeEdit).addClass("active");

					$.removeCookie(IVUser.cWatchlater_opened, { path: '/', domain: 'indavideo.hu' });
					$.cookie(IVUser.cSubscribe_opened, 1, { expires: 365, path: '/', domain: 'indavideo.hu' });
					$(mom.sMyContainer).height($(mom.sMyContainer).height());
					$(mom.sMyWatchLater).removeClass('active');
					$(mom.sWatchLaterList).fadeOut(300, function() {
						$(this).toggleClass('opened');
						$(mom.sSubscribesList).fadeIn(300, function() {
							$(this).toggleClass('opened');
							$(mom.sMySubscribtions).toggleClass('active');
							$(mom.sMyContainer).height("auto");
                        });
                    });
					_gaq.push(['t2._trackEvent', 'Subscribe', 'SubsBarSwitch', this.page]);
                }
                else if ($.cookie(IVUser.cSubscribe_opened) == 1 && $(mom.sSubscribesList).hasClass('opened')) {
                    $(IVUser.sSubscribeEdit).removeClass("active");

                    $.removeCookie(IVUser.cSubscribe_opened, { path: '/', domain: 'indavideo.hu' });
                    _gaq.push(['t2._trackEvent', 'Subscribe', 'SubsBarClose', this.page]);
					$(mom.sSubscribesList).slideToggle(200, function() {
						$(this).toggleClass('opened');
						$(mom.sMySubscribtions).toggleClass('active');
					});
				}
				else {
                    if ($(IVUser.sNewVideosCount).hasClass('active')) {
                        $(IVUser.sNewVideosCount).removeClass('active');
                        $.cookie(IVUser.cSubscribeNumClicked, 1, { expires: 1, path: '/', domain: 'indavideo.hu' });
                    }

                    if (!$(IVUser.sSubscribeEdit).hasClass("active"))
                        $(IVUser.sSubscribeEdit).addClass("active");

					$.cookie(IVUser.cSubscribe_opened, 1, { expires: 365, path: '/', domain: 'indavideo.hu' });
					_gaq.push(['t2._trackEvent', 'Subscribe', 'SubsBarOpen', this.page]);
					$(mom.sSubscribesList).slideToggle(200, function() {
						$(this).toggleClass('opened');
						$(mom.sMySubscribtions).toggleClass('active');
					});
				}
				$(mom.sSubscribedElements).find(mom.sLazy).trigger('lazyload');
			}
		}
	},

	watchlater: function(url_title, addremove, D)
	{
		var mom = IVUser;

		if ((!url_title || !addremove) && addremove != 0)
			return false;

        var target = (D.target instanceof jQuery) ? D.target : $(D.target);
        // console.log(target, D.target);
        target.addClass('pulsing');

		_gaq.push(['t2._trackEvent', 'Subscribe', 'SubsBarWatchLater', mom.page]);

		$.ajax(
		{
			url: mom.urlVideoHandler,
			type: "POST",
			dataType: 'json',
			data:
			{
				op: 'watchlater',
				action: 'videoHandler',
				addOrRemove: addremove,
				url_title: url_title
			},
			success: function(res)
			{
                target.removeClass('pulsing').removeAttr('title');
                if (!D.removeLayer) {
    				target.toggleClass("later");
                    if (target.hasClass(mom.sWatchLaterBtn.replace(/[\.\#]{1}/g, ""))) {
                        mom.addOpacityLayerToElement(target.closest(".item"),mom.constWATCHLATER);
                    }
                }
                else {
                    var item = (target.hasClass('item')) ? target : target.closest('.item');

                    IVUser.removeOpacityLayer(item);
                }
			} //function
		});
	},

	____: function(){}
};

var IVPlayList =
{
	sPlaylistContainer:		'#plContainer',
	sPagerHandle:			'.plPagerHandle',
	sPagerHandleLeft:		'#plPagerHandleLeft',
	sPagerHandleRight:		'#plPagerHandleRight',
	sPagerHandlePrev:		'#plPagerHandlePrev',
	sPagerHandleNext:		'#plPagerHandleNext',
	sPlayStripContainer:	'#plPlayStripContainer',
	sPlayStrip:				'#plPlayStrip',
	sPlayStrip_OL:			'#plPlayStrip ol',
	sPlayStripItems:		'#plPlayStrip ol li',
	sItemTitle:				'#itemTitle',
	sItemHelper:			'.itemHelper',
	sUndoLastAction:		'#undoLastAction',

	sDelActualPlaylist:		'#delActualPlaylist',

	sActionRemoveOverlay:	'span.actionRemoveOverlay',

	sPlaylistSelect:		'#plPlaylistSelect',
	sPlaylistSelect_SelectedOption:		'#plPlaylistSelect option:selected',
	sPlaylistToggle:		'.plToggle',

	sPlaylistShow:			'#plShow',
	sPlaylistHide:			'#plHide',

	sLoopToggle:			'.plLoopToggle',
	sLoopEnabled:			'#plLoopEnabled',
	sLoopDisabled:			'#plLoopDisabled',

	//Context menuitem, toggles the playlist on/off
	sTogglePlaylist:		'#showHideMyLists',

	sItemPrefix:			'#plv_',

	paddingOffset:			-5,
	animationDuration:		300,

	//Interval after playstrip moves one element either way with a dragged (sortable) element on pagerhandles
	intervalHoverScroll:	200,

	//Currently dragged item
	draggedItem:			null,

	//The last item id
	lastItemId:				0,

	//Stores the last deleted video element
	undoLastVideo:			{	id:null, url_title: null, playlistID: null, html: null	},

	//Current video played
	currentVideo:			'',

	//Current playlist ID - 1 by default, which is all videos per user
	currentPlaylistID:		1,

	//setTimeout/setInterval timer ids
	timerID:				{timeout : {}, interval: {}},

	textPlaylistHide: 		'Listáim elrejtése',
	textPlaylistShow: 		'Listáim mutatása',

	urlPlaylistBar:			'/playlist_bar/?load=1',
	urlLoadPlaylists:		'/playlist_bar?load=1&json=1',
	urlLoadPlaylistItems:	'/playlist/get/',
	urlPrefixVideoPage:		'/video/',
	urlPlaylistAdmin:		'/playlistadmin',

	cookiePlaylistLoop:		'playlist_loop',

	init: function()
	{
//EVENT HANDLERS

		$(document).on('click', this.sPlaylistToggle, {mom: this}, this.togglePlayStripVisibility);
		$(document).on('click', this.sLoopToggle, {mom: this}, this.toggleLoop);

		//video item mouseover - Show overlays, show actual video item title
		$(document).on('mouseover', this.sPlayStripItems, {mom:this}, this.eItemMouseOver);

		//video item mouseout - Hide video item title
		$(document).on('mouseout', this.sPlayStripItems, {mom:this}, this.eItemMouseOut);

		//video item click - navigate to video
		$(document).on('click', this.sPlayStripItems, {mom:this}, this.eItemClick);

		//Playstrip mouseleave actions - like remove negative sign overlay
		$(document).on('mouseleave', this.sPlayStrip, {mom:this}, this.ePlaystripMouseLeave);

		//right bottom negative sign overlay click - Remove video from playlist
		$(document).on('click', this.sActionRemoveOverlay, {mom:this}, this.eActionRemoveOverlayClick);

		//Undo option - click
		$(document).on('click', this.sUndoLastAction, {mom:this}, this.eRestoreUndo);

		//Show/hide playlist - from profile context menu
		$(document).on('click', this.sTogglePlaylist, {mom: this}, this.eTogglePlaylistVisibility);

		//Playlist dropdown playlist change
		$(document).on('change',this.sPlaylistSelect, {mom: this}, this.ePlaylistSelectChange);

		//$(this.sDelActualPlaylist).live('click',{mom: this}, this.eDelActualPlaylistClick);

		$(document).on('click', this.sPagerHandle, {mom: this}, this.ePagerHandleClick);
		$(document).on('mouseover', this.sPagerHandle,  {mom: this}, this.ePagerHandleOver);
		$(document).on('mouseout', this.sPagerHandle,  {mom: this}, this.ePagerHandleOut);

//INIT BASICS

		//Current video played
		this.currentVideo = window.location.pathname.split('/')[2];

		if ( IV.sys.GET.pid )
		{
			this.currentPlaylistID = IV.sys.GET.pid;

			//IF PID is set, then we have to show the playlist
			this.eTogglePlaylistVisibility();
		} //if
	},

	ePagerHandleOver: function(e)
	{
			var mom = e.data.mom;

//			IV.log('over');

			if (mom.draggedItem != null)
			{
				var itemOffset = mom.draggedItem.offset();

				IV.log('offset');
				IV.log(itemOffset);
			} //if

			if (mom.draggedItem != null)
			{
				//IV.log('GotItem!');
				switch($(this).attr('id'))
				{
					case mom.sPagerHandleLeft.substr(1):
						mom.changePosition('-1', {animationDuration: 0});

						IV.log('left');

						clearInterval(mom.timerID.interval.changePosition);
						mom.timerID.interval.changePosition = null;
						mom.timerID.interval.changePosition = setInterval(function()
						{
							if (mom.timerID.interval.changePosition)
							{
								mom.changePosition('-1',{animationDuration: 0})
							}
						}, mom.intervalHoverScroll);

						IV.log('<<');
					break;

					case mom.sPagerHandleRight.substr(1):
						mom.changePosition('+1', {animationDuration: 0});

						IV.log('right');

						clearInterval(mom.timerID.interval.changePosition);
						mom.timerID.interval.changePosition = null;
						mom.timerID.interval.changePosition = setInterval(function()
						{
							if (mom.timerID.interval.changePosition)
							{
								mom.changePosition('+1',{animationDuration: 0})
							}
						}, mom.intervalHoverScroll);

						IV.log( 'intervalID:' + mom.timerID.interval.changePosition );

						IV.log('>>');
					break;
				} //switch
			} //if
	},

	ePagerHandleOut: function(e)
	{
		var mom = e.data.mom;

		if (mom.draggedItem != null)
			mom.draggedItem.css('position','absolute');

		//IV.log(mom.timerID.interval.changePosition);
		clearInterval(mom.timerID.interval.changePosition);
		mom.timerID.interval.changePosition = null;
	},

	eActionRemoveOverlayClick: function(e)
	{
		var mom = e.data.mom;

		IV.log('remove');

		mom.removeFromPlaylist( mom.currentPlaylistID, $(this).parent('li') );

		e.stopPropagation();

		return;
	},

	ePlaylistSelectChange: function(e)
	{
		var mom = e.data.mom;

		mom.loadPlaylistItems( $(mom.sPlaylistSelect_SelectedOption).val() );

		mom.hideUndoOption();
	},

	hideUndoOption: function()
	{
		$(this.sUndoLastAction).hide();
	},

	eItemMouseOver: function(e)
	{
		var mom = e.data.mom;

		//Show video title
		$(mom.sItemTitle).text( $(this).attr('_title') );

		if (mom.currentPlaylistID != 1)
			var aro = $(this).children('span.actionRemoveOverlay').show();
	},

	eItemMouseOut: function(e)
	{
		var mom = e.data.mom;
		var aro = $(this).children('span.actionRemoveOverlay');

		$(mom.sItemTitle).text( '' );

		$(aro).hide();
	},

	eItemClick: function(e)
	{
		var mom = e.data.mom
		var loc = mom.urlPrefixVideoPage + $(this).attr('_url_title') + '?pid=' + mom.currentPlaylistID;

		//ctrl+click, open video in new window
		if (e.ctrlKey)
		{
			e.preventDefault();
			window.open(loc,'_blank');
		}
		//Open in current window
		else
		{
			window.location.href = loc;
		} //if
	},

	ePlaystripMouseLeave: function(e)
	{
		var mom = e.data.mom;

		//$(mom.sActionRemoveOverlay).hide();
	},

	addItem: function(data, opt)
	{
		if (!data)
			return false;

		var self = this;
		var ps = $(this.sPlayStrip_OL);
		var itemID = ++this.lastItemId;

/*
data:
	"hash": "3ec0374d41",
	"title": "Hargitai Bea fot\u00f3z\u00e1sa",
	"url_title": "Hargitai_Bea_fotozasa",
	"thumbnail": "http:\/\/pics.izsof.test.indavideo.hu\/videos\/210\/602\/2.jpg",
	"id": "210602"
*/

		if (!this.isItemIDAvailable(data.id))
		{
			//Returns newly added item
			ps.append('<li id="'+this.sItemPrefix.substr(1)+data.id+'"><span class="actionRemoveOverlay"></span><div style="width: 120px; height: 70px; overflow: hidden; margin:3px;"><img src="'+data.thumbnail+'" ></div></li>');
			//<span class="actionRemoveOverlay" style="top: 66px; left: 496px; display: none;"></span>

			//IV.log(data.url_title);
			//IV.log(this.currentVideo);

			//Change border for currently playing element
			if (data.url_title == this.currentVideo)
			{
				IV.log('playing');
				$(this.sItemPrefix + data.id).addClass('playing');
			} //if

			//Setting attributes
			$.each(data, function(i,v)
			{
				//IV.log( self.sItemPrefix + data.id );
				//Return actual LI object
				$(self.sItemPrefix + data.id).attr('_'+ i, v);
			});
		} //if

		return false;
	},

	/**
	* Substitute of delItem
	*
	* @param id
	*/
	delItem: function(id)
	{
		this.removeItem(id);
	},

	removeItem: function(id)
	{
		if ( /^plv_[0-9]+$/i.test(id) )
		{
			$('#' + id).remove();
		}
		else
		{
			//Store item in undo
			$(this.sItemPrefix + id).remove();
		} //if
	},

	removeItems: function()
	{
		$(this.sPlayStripItems).remove();
	},

	ePagerHandleClick: function(e)
	{
		mom = e.data.mom;

		switch( $(this).attr('id') )
		{
			case mom.sPagerHandleLeft.substr(1):
				mom.changePosition('-page');
			break;

			case mom.sPagerHandleRight.substr(1):
				mom.changePosition('+page');
			break;

			case mom.sPagerHandlePrev.substr(1):
				mom.playVideo('prev');
			break;

			case mom.sPagerHandleNext.substr(1):
				mom.playVideo('next');
			break;
		} //switch
	},

	playVideo: function(action)
	{
		switch(action)
		{
			case 'prev':
				var url_title = $( this.sPlayStripItems + '[_url_title="'+this.currentVideo+'"]' ).prev().attr('_url_title');

				if (!url_title)
				{
					this.playVideo('last');
					return;
				} //if
			break;

			case 'next':
				var url_title = $(this.sPlayStripItems + '[_url_title="'+this.currentVideo+'"]' ).next().attr('_url_title');

				if (!url_title)
				{
					this.playVideo('first');
					return;
				} //if
			break;

			case 'first':
			IV.log('first');
				var url_title = $(this.sPlayStripItems + ':first' ).attr('_url_title');
			break;

			case 'last':
				IV.log('last');
				var url_title = $(this.sPlayStripItems + ':last' ).attr('_url_title');
			break;
		} //switch

		window.location.href = mom.urlPrefixVideoPage + url_title + '?pid=' + mom.currentPlaylistID;
	},

	//rename
	getPlayingVideo: function()
	{

	},

	changePosition: function(movement, opt)
	{
		if ( $.isEmptyObject(opt) )
		{
			opt = this;
		} //if

		//Get the strip width
		var stripWidth = this.getPlayStripWidth();

		//Get playlist item width
		var iWidth = this.getPlayListItemWidth();

		//We have to relocate to the itemPerStrip+1 nth element
		//itemPerStrip stores how many items are FULLY visible on the strip
		var itemPerStrip = Math.floor(stripWidth / iWidth);

		//The leftmost item in the strip
		var actualItem = this.getActualItem();

		//The item count in the strip
		var countItem = this.getCountItem();

		//The new, leftmost item position where the scroller has to position itself
		//By default its the same as actualItem, so we won't budge
		//var itemNewPosition = actualItem;

		position = actualItem;
		movement = movement + '';

		//Adding/subtracting
		if ( $.inArray(movement.charAt(0),['+','-']) != -1)
		{
			switch(movement.charAt(0))
			{
				case '+':
					//Move one full page right
					if (movement.substr(1) == 'page')
					{
						if (actualItem < countItem)
						{
							position = actualItem + (itemPerStrip);

							//Get to the first element
							if ( position > countItem)
							{
								position = countItem;
							} //if
						}
						//Do nothing, since actualItem = countItem
						else
						{

						} //if
					}
					//Move n element right
					else
					{
						IV.log( movement.substr(1) );
						position = actualItem + parseInt(movement.substr(1));
					}
				break;

				case '-':
					if (movement.substr(1) == 'page')
					{
						//We are at last element, sooo
						//We have 6 visible items
						//38 39 40 41 42 43 44 |45 46 47 48 49 50|END
						//Show it from 39
						if (actualItem >= (countItem-itemPerStrip) )
						{
							position = countItem - (itemPerStrip*2-1);
						}
						else if (actualItem > 1)
						{
							position = actualItem - (itemPerStrip);

							//Get to the first element
							if ( position < 1)
							{
								position = 1;
							} //if
						}
						//Do nothing, since actualItem = 1
						else
						{
						} //if
					}
					else
					{
						IV.log( movement.substr(1) );
						position = actualItem - parseInt(movement.substr(1));
					} //if
				break;
			} //switch

			if ( position > countItem )
			{
				position = countItem;
			}
			else if (position < 1)
			{
				position = 1;
			} //if
		}
		//Specific itemNO given
		else
		{
			position = parseInt(movement);
		} //if

		this.setActualItem(position);

//		$(this.sPlayStrip + ' li:nth-child(' + position +')')

		//$(mom.sPlayStrip).scrollTo($(mom.sItemPrefix+itemNewPosition), mom.animationDuration,
		$(this.sPlayStrip).scrollTo( $(this.sPlayStrip + ' li:nth-child(' + position +')') , opt.animationDuration,
		{
			offset: this.paddingOffset,
			easing: 'easeInOutCirc'
		});

		/*
		$(mom.sPlayStrip).stop().animate(
		{
	        scrollLeft: $(mom.sItemPrefix+itemNewPosition).offset().left
		}, 100,'easeOutQuint');
		*/
	},

	togglePlayStripVisibility: function(e)
	{
		var mom = e.data.mom;

		switch( $(this).attr('id') )
		{
			case mom.sPlaylistShow.substr(1):
				mom.showPlayStrip();
			break;

			case mom.sPlaylistHide.substr(1):
				mom.hidePlayStrip();
			break;
		} //switch
	},

	showPlayStrip: function()
	{
		$(this.sPlayStripContainer).show();
		$(this.sPlaylistShow).hide();
		$(this.sPlaylistHide).show();
	},

	hidePlayStrip: function()
	{
		//we have to (re)store scroll position, since webkit resets scrollLeft after a display: none
		$(this.sPlayStripContainer).hide();
		$(this.sPlaylistShow).show();
		$(this.sPlaylistHide).hide();

		this.hideUndoOption();
	},

	isPlaylistVisible: function()
	{
		return $(this.sPlaylistContainer).is(':visible');
	},

	isPlaylistLoaded: function()
	{
		//By default sPlayListContainer is totally empty... if it has one ascending div, its considered loaded
		return ($(this.sPlaylistContainer + ' div').length > 0 ? true : false);
	},

	eTogglePlaylistVisibility: function(e)
	{
		if (e)
			var mom = e.data.mom;
		//Called from init
		else
			var mom = this;

		//SHOW
		if (!mom.isPlaylistVisible())
		{
			mom.showPlaylist();
		}
		//HIDE
		else
		{
			mom.hidePlaylist();
		} //if

		mom.loadPlaylistHTML();
	},

	/**
	* Show Playlist with playstrip maximized
	*
	*/
	showAll: function()
	{
		this.showPlaylist();
		this.showPlayStrip();
	},

	showPlaylist: function()
	{
		$(this.sPlaylistContainer).show();
		//Also change the context text
		$(this.sTogglePlaylist).html(this.textPlaylistHide);
	},

	hidePlaylist: function()
	{
		$(this.sPlaylistContainer).hide();
		//Also change the context text
		$(this.sTogglePlaylist).html(this.textPlaylistShow);
	},

	/**
	*
	* Load Playlist HTML structure and
	* get playlists, show first or selected and its contents
	*
	*/
	loadPlaylistHTML: function( opt )
	{
		var self = this;

		if (!opt)
			opt = {};

		//If playlist not yet loaded, loooad it
		if ( !this.isPlaylistLoaded() || opt.reload )
		{
			$(this.sPlaylistContainer).load(this.urlPlaylistBar,

			//onSuccess
			function()
			{
				//-*-*-* Load events onPlaylistLoad
				self.eventsOnPlaylistHTMLLoad();

				//IV.log('cookie', $.cookie(self.cookiePlaylistLoop) );

				//Looping enabled
				if ($.cookie(self.cookiePlaylistLoop) == '1')
				{
					//IV.log('ENABLED');
					//Inverse logic... in order to enable looping, the disable element must be clicked
					$(self.sLoopDisabled).trigger('click');
				}
				else
				{
					$(self.sLoopEnabled).trigger('click');
				} //if

				//-*-*-* Set sortable
				$(IVPlayList.sPlayStrip_OL).sortable(
				{
					position: 'fixed',
					axis: 'x',
					distance: 5,
					tolerance: 'pointer',
					scrollSensitivity: 1,

					start: function(e, ui)
					{
						IV.log('dragstart');
						IVPlayList.draggedItem = ui.item;

						//Create helpers at each end
						//$(IVPlayList.sPlayStrip_OL).prepend('<li class="'+IVPlayList.sItemHelper.substr(1)+'"><div style="width: 120px; height: 70px; overflow: hidden; margin:3px;"></div></li>');
						//$(IVPlayList.sPlayStrip_OL).append('<li class="'+IVPlayList.sItemHelper.substr(1)+'"><div style="width: 120px; height: 70px; overflow: hidden; margin:3px;"></div></li>');
					},

					stop: function(e, ui)
					{
						IV.log('dragend');
						IVPlayList.draggedItem = null;

						//Destroy helpers
						//$(IVPlayList.sItemHelper).remove();
					}
				});

				//Load playlist
				if (!opt.noplaylist)
					self.loadPlaylists();

				//Callback baby
				if (opt.onSuccess)
					opt.onSuccess();
			});
		} //if
	},

	eventsOnPlaylistHTMLLoad: function()
	{
		//Delete actual playlist - click
		IVHelper.usure(this.sDelActualPlaylist,
		{
			question: 'Biztos vagy benne?',
			execute: this.eDelActualPlaylistClick,
			executeParameters: [{data: {mom: this}}]
		});
	},

	clearPlaylists: function()
	{
		$(this.sPlaylistSelect).find('option')
		.remove();
	},

	/**
	* Load playlists and display given or default (playlistID = 1 - all videos) playlist by ID
	*
	* @param playlistID Playlist to select and display its contents
	*/
	loadPlaylists: function(playlistID)
	{
		var self = this;

		if (!playlistID)
			playlistID = self.currentPlaylistID;

		$.ajax(
		{
			url: this.urlLoadPlaylists,
			type: 'GET',
			dataType: 'json',
			data: {
				"pid" : playlistID
			},
			success: function(res)
			{
				self.clearPlaylists();

				var options = $(self.sPlaylistSelect);

				$.each(res, function()
				{
				    options.append($("<option />").val(this.id).text(this.title));
				});

				//Select actual playlist from dropdown
				if ( ! self.selectPlaylistMenuItemBy({by: 'id', value: playlistID }).length   )
				{
					//if failed, then fallback to all the videos
					playlistID = 1;
					self.selectPlaylistMenuItemBy({by: 'id', value: playlistID })
				} //if

				self.loadPlaylistItems(playlistID);
			} //function
		});
	},

	loadPlaylistItems: function(playlistId)
	{
		var self = this;

		//set playlistID - this must be moved, if loadPlaylistItems will be used as static func
		self.currentPlaylistID = playlistId;

		//ERROR
		if (!playlistId)
			return false;

		$.ajax(
		{
			url: this.urlLoadPlaylistItems + playlistId,
			type: 'GET',
			dataType: 'json',
			success: function(res)
			{
				var data = null;

				self.removeItems();

				//Custom format
				if (playlistId == 1)
				{
					data = res.data;
				}
				else
				{
					data = res;
				} //if

				$.each(data, function(i, v)
				{
					self.addItem(v);
				});

				//Trigger sortable refresh
				//$(IVPlayList.sPlayStrip_OL).sortable('refresh');

				//Scroll back to the first element
				self.changePosition(1,{animationDuration: 0});

				//Show or hide playlist delete action
				if
				(
					self.currentPlaylistID == 1 || $(self.sPlaylistSelect).find('option:contains("Kedvenceim")').prop('selected')
				)
				{
					$(self.sDelActualPlaylist).hide();
				}
				else
				{
					$(self.sDelActualPlaylist).show();
				} //if

				//Scroll to actual video element
				if (playlistId == IV.sys.GET.pid)
				{
					self.changePosition(self.getCurrentVideoPosition(), {animationDuration: 0});
				} //if

			} //function
		});
	},

	getCurrentVideoPosition: function()
	{
		//index returns a zero based order position, hence the +1
		return $(this.sPlayStripItems).index( $(this.sPlayStripItems + '[_url_title="'+this.currentVideo+'"]' ) )+1;
	},

	selectPlaylistMenuItemBy: function(opt)
	{
		switch(opt.by)
		{
			case 'value':
			case 'id':
				return $(this.sPlaylistSelect).find('option[value="'+opt.value+'"]').prop('selected',true);
			break;

			case 'content':
			case 'text':
				return $(this.sPlaylistSelect).find('option:contains("'+opt.value+'")').prop('selected',true);
			break;
		} //switch
	},

	eDelActualPlaylistClick: function(e)
	{
		var mom = e.data.mom;

		IV.log(this);

		mom.delPlaylist( mom.currentPlaylistID );
	},

	delPlaylist: function(playlistID)
	{
		var mom = this;

		$.post (
		this.urlPlaylistAdmin,
		{
			action: 'videoHandler',
			op: 'removePlaylist',
			pid: playlistID
		},
		function (data)
		{
			mom.removeItems();

			//Remove playlist item from the select - dead sure alternative :)
			//$(mom.sPlaylistSelect).find('option[value="'+playlistID+'"]').remove();
			//Remove currently selected playlist item from the select
			$(mom.sPlaylistSelect_SelectedOption).remove();

            $("#context_thumbnail table tbody tr#playlist_" + playlistID).remove();

			//Select all my videos option
			mom.loadPlaylistItems( 1 );
		}, 'json');
	},

	addToPlaylist: function(playlistID, url_title)
	{
		var self = this;
		IV.log(url_title);
		IV.log( $("#context_thumbnail .what").html() );

		$.post (
		this.urlPlaylistAdmin,
		{
			action: 'videoHandler',
			op: 'addToPlaylist',
			hash: $("#emb_hash").val(),
			url_title : (url_title ? url_title : $("#context_thumbnail .what").html() ),
			pid: playlistID,
			addOrRemove: 1
		},
		function (data)
		{
			var data = data;

			$("#context_thumbnail").fadeOut ();
			loaded = false;
			getPlayListHTML();

			IV.log('mancineni');

			//Playlist struktura betoltve, csak playlisteket toltjuk ujra
			if ( self.isPlaylistLoaded() )
			{
				IV.log('herre');
				IVPlayList.loadPlaylists( playlistID );
				IVPlayList.showAll();
			}
			//Be kell huznunk a playlist struktot is
			else
			{
				//?TODO: Switch to playlist, show item added
				self.loadPlaylistHTML(
				{
					noplaylist: 1,

					onSuccess: function()
					{
						IV.log('herre');
						IVPlayList.loadPlaylists( playlistID );
						IVPlayList.showAll();
					} //function
				});
			} //if

		}, 'json');
	},

	createPlaylist: function (title, url_title, newMainpage)
	{
		var self = this;

        if ($("#context_thumbnail").length != 0)
            var playlistCount = $("#context_thumbnail table tbody tr").size();
        else
            var playlistCount = $('.playlists').first().find('li').length;

		if (playlistCount >= 28) // 25, csak van 3 static tr is a table-ben
		{
			$("#context_thumbnail").fadeOut();
			myAlert ('Már túl sok listát hoztál létre!', 'Új lista');
			return false;
		} //if

		$.post (this.urlPlaylistAdmin,
		{
			action: 'videoHandler',
			op: 'createPlaylist',
			//video beloldal
			hash: $("#emb_hash").val(),
			//fooldal
			url_title: url_title,
			title: title
		},
		function (data)
		{
			if (typeof data.success === 'undefined');
			else if (typeof data.playlist === 'undefined');
			else if (data.success != '1');
				//alert ('nem1');
			else
			{
    			var html = '<tr class="menu_item"><td class="cm_bg"><div class="content">'
    				+ '<a href="#" onclick="videoBoxHandler.addToPlaylist(' + data.playlist.id + ');showPlaylists(); return false;">' + data.playlist.title + '</a> '
    				+ '</div></td></tr>';
    			$("#context_thumbnail table tbody tr").last().before(html);

    			//$("#context_thumbnail").fadeOut();
                if (typeof hideAddPlaylistForm == 'function')
                    hideAddPlaylistForm ();
                else
                    mainpage.closePlaylistMenu();
    			//myAlert ('A listát létrehoztuk, a videót hozzáadtuk!', 'Új lista');

    			//Playlist struktura betoltve, csak playlisteket toltjuk ujra
    			if ( self.isPlaylistLoaded() )
    			{
    				self.loadPlaylists( data.playlist.id );
    				self.showAll();
    			}
    			//Be kell huznunk a playlist struktot is
    			else
    			{
    				self.loadPlaylistHTML(
    				{
    					noplaylist: 1,
    					onSuccess: function()
    					{
    						self.loadPlaylists( data.playlist.id );
    						self.showAll();
    					}
    				});
    			} //if
			    getPlayListHTML();

			};
		}, 'json');
		return false;
	},

	removeFromPlaylist: function(playlistID, jqItem/*LI element*/)
	{
		var mom = this;

		$.post (this.urlPlaylistAdmin,
		{
			action: 'videoHandler',
			op: 'addToPlaylist',
			hash : '',
			url_title : $(jqItem).attr('_url_title'),
			pid: playlistID,
			addOrRemove: 0
		},
		function (data)
		{
			mom.storeUndo
			({
				id: $(jqItem).attr('_id'),
				playlistID: playlistID,
				url_title: $(jqItem).attr('_url_title'),
				//outerHTML :P
				html: $(jqItem).clone().wrap('<p>').parent().html()
			});

			mom.removeItem($(jqItem).attr('_id'));
			//myAlert ('A videót töröltük a listáról!', 'Törlés a listáról');
		}, 'json');
	},

	storeUndo: function(data)
	{
		this.undoLastVideo = data;

		$(this.sUndoLastAction).show();
	},

	eRestoreUndo: function(e)
	{
		var mom = e.data.mom;

		mom.restoreUndo();
	},

	restoreUndo: function()
	{
		if ( this.undoLastVideo.id )
		{
			//addtoplaylist
			this.addToPlaylist(this.undoLastVideo.playlistID, this.undoLastVideo.url_title);

			//Change to playlist
			this.selectPlaylistMenuItemBy({by: 'id', value: this.undoLastVideo.playlistID })

			this.hideUndoOption();
		} //if
	},

	addRate: function ()
	{
		$.post (this.urlPlaylistAdmin,
		{
			action: 'videoHandler',
			op: 'rateVideo',
			hash: $("#emb_hash").val()
			//,url_title: $("#context_thumbnail .what").html()
		},
		function (data)
		{
			if (typeof data.success != 'undefined')
			{
				if (data.success == '1')
					myAlert ('A szavazatot rögzítettük!','Szavazás videóra');
				else
					myAlert ('Már szavaztál!', 'Szavazás videóra');
			} //if
		}, 'json');
	},

	setFavourite: function(i,elem)
	{
		var url_title = "";

		if (elem) {
			url_title = ($("#context_thumbnail .what").html().lenght) ? $("#context_thumbnail .what").html() : elem.find("input").val();
		}
		else
			url_title = $("#context_thumbnail .what").html();

		$.post (
		this.urlPlaylistAdmin,
		{
			action: 'videoHandler',
			op: 'setFavourite',
			hash: $("#emb_hash").val(),
			url_title : url_title,
			addOrRemove: 1
		},
		function ()
		{
			$("#context_thumbnail").fadeOut ();
			myAlert ('A videót hozzáadtuk!', 'Kedvencekhez adás');
			loaded = false;
			getPlayListHTML();
		}, 'json');
	},

	toggleLoop: function(e)
	{
		var mom = e.data.mom;

		//IV.log('LOOPA');

		switch( $(this).attr('id') )
		{
			case mom.sLoopEnabled.substr(1):
				$(mom.sLoopEnabled).hide();
				$(mom.sLoopDisabled).show();
//IV.log('NO LOOP');
				//Delete, no looping
				$.cookie(mom.cookiePlaylistLoop, 0, {path: '/', expires: 365, domain: document.domain } );
			break;

			case mom.sLoopDisabled.substr(1):
				$(mom.sLoopEnabled).show();
				$(mom.sLoopDisabled).hide();
//IV.log('LOOP SET');
				$.cookie( mom.cookiePlaylistLoop, 1, {path: '/', expires: 365, domain: document.domain } );
			break;
		} //switch

		IV.log(mom.isLooping());
	},


// IS? - STATECHECKS

	isLooping: function()
	{
		if ( $(this.sLoopEnabled).is(':visible'))
			return true;
		else
			return false;
	},

	isItemIDAvailable: function(itemID)
	{
		return ( $( this.sItemPrefix + itemID).length > 0 ? true : false );
	},


// SETTER-GETTERS

	getPlayStripWidth: function()
	{
		return parseInt( $(this.sPlayStrip).outerWidth() );
	},

	getPlayListItemWidth: function()
	{
		return parseInt( $(this.sPlayStrip + ' li:first-child').outerWidth() );
	},

	getActualItem: function()
	{
		return parseInt( $(this.sPlayStrip).attr('actualItem') );
	},

	setActualItem: function(actualItem)
	{
		$(this.sPlayStrip).attr('actualItem',actualItem);
	},

	getCountItem: function()
	{
		return parseInt( $(this.sPlayStripItems).length );
	},

	____: function(){}
};

var IVHelper =
{
	/**
	* Replace original text with a confirmation question and restores the original text after n seconds on mousout
	*
	* @param elem mixed jQuery selector
	*
	* Example: IVHelper.confirmationText(
	* {
	* 	execute: execute function on confirmed click
	* 	question: 'Delete, for sure?', //Confirming question to ask on first click
	* });
	*
	*
	*/

	usure: function(elem, opt)
	{
		$.each($(elem), function(i,element)
		{
			if (! $(element).data('usure_init') )
			{
				$(element).data('usure_init', 1);
				$(element).data('usure_execute', opt.execute);
				$(element).data('usure_textorigi', $(element).text() );

				$(element).on('click', function(e)
				{
					if ( $(this).data('usure_asked') == 1 )
					{
						if (opt.execute)
							opt.execute.apply(this, opt.executeParameters);

					}
					else
					{
						$(this).data('usure_asked',1);

						$(this).text(opt.question);

						e.preventDefault();
					}
				});

				$(element).on('mouseout', function(e)
				{
					var self = this;

					$(this).data('usure_timerid',
					setTimeout(function()
					{
						$(self).text( $(self).data('usure_textorigi') );
						$(self).data('usure_asked',0);
					}, 1000) );
				});

				$(element).on('mouseover', function(e)
				{
					var self = this;

					//Got timer, clear it
					if ( $(this).data('usure_timerid') )
					{
						clearTimeout($(this).data('usure_timerid'));
						$(this).data('usure_timerid',null);
					} //if
				});
			} //if

		});
	} //function


};

var IVSystem =
{
	GET:				{},
	URLPATH:			[],

	init: function()
	{
		this.parseURLParameters();
		this.parseURLPath();
	},

	parseURLParameters: function()
	{
	    var match,
	        pl     = /\+/g,  // Regex for replacing addition symbol with a space
	        search = /([^&=]+)=?([^&]*)/g,
	        decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
	        query  = window.location.search.substring(1);

	    while (match = search.exec(query))
	       this.GET[decode(match[1])] = decode(match[2]);
	},

	parseURLPath: function()
	{
		this.URLPATH = window.location.pathname.substr(1).split('/');
	},

	____: function(){}
};

var IVSection = 
{
	sNewCommentText:		'#new_comment_text',
	
	init: function()
	{
		var sectionName = IVSystem.URLPATH[0].charAt(0).toUpperCase() + IVSystem.URLPATH[0].slice(1);

		//if init exists inside our object, then CAALLLL BIATCH
		if (window["IVSection"+sectionName] && sectionName && "init" in window["IVSection"+sectionName])
		{
			window["IVSection"+sectionName].init();
		} //if
	},

	____: function(){}
};

var IVSectionVideo = 
{
	sNewCommentForm:			'#new_comment_form',
	sNewCommentText:			'#new_comment_text',
	sCommentErrorText:			'.error_text',

	sCommentDotAnimation:		'#dot_cont span',
	sCommentSubmitContainer:	'.submitButton_container',

	storLastComment:			'iv_comment_last',

	init: function()
	{
		//this.events();
		if (window.location.hash == '#newcomment')
		{
			$(this.sNewCommentText).focus();
		} //if

		if (IVSystem.GET.op == 'comment_subscribe' && typeof IVSystem.GET.success != 'undefined')
		{
			if 
			(
				typeof window.history.pushState == 'function'
				// && window.location.hash != '#nagyitas' 
			)
			{
				history.replaceState(null, '', location.protocol + '//' + location.host + location.pathname);

				//todo: notification
  			} //if
		} //if

		//Restore comment
		if (IVSystem.GET.restore == 1)
		{
			history.replaceState(null, '', location.protocol + '//' + location.host + location.pathname);
			this.commentRestore();
		} //if

		this.events();
	},

	events: function()
	{
		$(this.sNewCommentForm).on('submit', {mom:this}, this.eSubmitNewCommentForm );
	},
	
	commentRestore: function()
	{
		$(this.sNewCommentText).val(localStorage.getItem(this.storLastComment));
	},
	
	commentSave: function(redirect)
	{
		localStorage.setItem(this.storLastComment, $(this.sNewCommentText).val());
		if (redirect)
		{
			window.location = location.protocol + '//' + location.host + location.pathname + "?restore=1#newcomment";
		}
	},

	commentStartDotAnimation: function()
	{
		$(this.sCommentSubmitContainer).addClass("loading");

		doDotDotDotBlinking(this.sCommentDotAnimation);

		var inter = setInterval(function() 
		{
			doDotDotDotBlinking(IVSectionVideo.sCommentDotAnimation);
		},1600);
		
		return inter;
	},

	commentStopDotAnimation: function(loopid)
	{
		clearInterval(loopid);
		$(this.sNewCommentText).addClass("errorous");
		$(this.sCommentSubmitContainer).removeClass("loading");
		$(this.sNewCommentText).focus();
	},

	checkCommentText: function()
	{
		return !(!$(this.sNewCommentText).size() || !$(this.sNewCommentText).val().length);
	},

	eSubmitNewCommentForm: function(e)
	{
		var mom = e.data.mom;
		var loopid = mom.commentStartDotAnimation();

		if (! mom.checkCommentText()) 
		{
			mom.commentStopDotAnimation(loopid);
			return false;
		} //if

		$(mom.sCommentErrorText).hide();
		$(mom.sNewCommentText).removeClass("errorous");
		$(mom.sNewCommentText).attr('readonly',true);
		$(mom.sNewCommentForm).addClass('readonly');

		$.ajax
		({
			type: 'POST',
			url: '/commentform',
			data: $(mom.sNewCommentForm).serialize(),
			dataType: 'json',
			error: function(jqXHR, textStatus, errorThrown) 
			{
			    $(mom.sNewCommentText).attr('readonly',false);
			    $(mom.sNewCommentForm).removeClass('readonly');

			    /*Szniki taktika*/
			    $(mom.sNewCommentText).addClass("errorous");
			    $(mom.sCommentSubmitContainer).removeClass("loading");

				$.ajax
				({
					type: 'POST',
					url: '/uglybetty.php',
					data: 
					{
						'ho': 'flt',
						'area': 'commenterror',
						'data' : JSON.stringify([textStatus,errorThrown,jqXHR])
					},
					complete: function()
					{
					    if(typeof(Storage) !== "undefined") 
					    {
					    	mom.commentSave(1);
					    } //if
					}
				});
			},
			success: function(R, textStatus, jqXHR) 
			{
				if (R.status == 'dupe')
				{
					$(mom.sCommentErrorText).text('Duplikált hozzászólás!').show();
				}
				else
				{
					$(mom.sCommentErrorText).hide();
					$(mom.sNewCommentText).val('').focus();
				} //if

				localStorage.removeItem('iv_comment_last');

				$(mom.sNewCommentText).attr('readonly',false);
				$(mom.sNewCommentForm).removeClass('readonly');
				$(mom.sCommentSubmitContainer).removeClass("loading");
				clearInterval(loopid);

				if (typeof ajaxPageLoad == 'function')
					ajaxPageLoad("p_comments", 1, false, true);
				else if (loopr_playersite)
					loopr_playersite.refreshComments(true,true);

				if (videobox && !$(videobox.sFeedFeedback).hasClass('active'))
					$(videobox.sFeedFeedback).click();
			}
		});

		return false;
	},

	____: function(){}
};

var IVMainPage =
{
	sListItem: ".BOX_CONTENT.INDEXVIDEO_NAGY .item",
	sDescription: ".description",

	init: function() {
		this.setDescriptionCrop();
	},

	setDescriptionCrop: function() {
		var self = IVMainPage;

		$(self.sListItem).each(function() {
			$(this).find(self.sDescription).dotdotdot({
				height		: "60px",
			});
		});
	}
};

var IVTemplate = 
{
	compiledTemplate:			[],

    configOptions:              {},

	//Cached output
	cache:						[],

	init: function()
	{
		//do something terrible
	},

	emptyCache: function()
	{
		this.cache = [];
	},
	
	isCached: function(cacheName)
	{
		if ( this.cache[cacheName] )
			return true;
			
		return false;
	},

	getCached: function(cacheName, target)
	{
		if (this.isCached(cacheName))
		{
			if (target)
			{
				$(target).html( this.cache[cacheName] );
			} //if

			return this.cache[cacheName];
		} //if

		return '';
	},
 
 	display: function(opt)
 	{
 		var mom = this;
 
		if ( !opt.template || !opt.data || ! opt.target )
		if ( !opt.template || (!opt.data && !opt.ajaxOptions) || ! opt.target )
 			return false;
 
 		//Got a cache id, so check if we've ever rendered this content
 		if (opt.cache && ! opt.forceRender)
 		{
 			if ( this.isCached(opt.cache) )
 			{
 				this.getCached(opt.cache,opt.target);

 				if (!opt.dontScroll && typeof profil == "object")
 					profil.movePager();
 				
 				return "";
 			} //if
 		} //if
 
 		opt.templateID = $(opt.template).prop('id');
 
 		//Template not yet exists, so compile
 		if (!this.compiledTemplate[ opt.templateID ] || opt.forceCompile)
 		{
 			this.compiledTemplate[ opt.templateID ] = dust.compile( $(opt.template).html(), opt.templateID);
 		} //if
 
 		// dust.isDebug = true;
 		// dust.debugLevel = 'DEBUG';
 		dust.loadSource(this.compiledTemplate[ opt.templateID ]);
 
		if (opt.ajaxOptions)
		{
			var ajaxopts = $.extend({momopt: opt}, opt.ajaxOptions);

			$.ajax( ajaxopts )
			.done
			(
				function(data, textStatus)
				{
					$.each(data, function(i,item) {
						if (item.PUBLIC_TAGS) {
							data[i].TAGS = [];
							$.each(item.PUBLIC_TAGS,function(index, tag) {
								data[i].TAGS.push(tag);
							});
						}
					});

					this.momopt.data = {
						"items" : data
					};


                    mom.configOptions = this.momopt;

					mom.render();

					if (typeof profil == "object")
						profil.reinitCarousels();

					if (!opt.dontScroll && typeof profil == "object")
						profil.movePager();
				} //function
			);
		}
		else
		{
            mom.configOptions = opt;
			mom.render();

			if (typeof profil == "object")
				profil.reinitCarousels();

			if (!opt.dontScroll && typeof profil == "object")
				profil.movePager();
		} //if
	},

	render: function()
	{
		var mom = this;

 		dust.render( mom.configOptions.templateID , mom.configOptions.data, mom.renderCallback);
 	},

    renderCallback: function(err, out) 
    {
        var mom = IVTemplate;

        if (err)
            console.log(err);
        else
        {
            if (mom.configOptions.cache)
                mom.setCacheByKey(mom.configOptions.cache, out);

            // ez itt gááááány!! értelmesebb nevet kell neki adni, mert félrevezet
            // ez a replace arra vonatkozik, hogy a "more" gomb helyére replace-eljen-e !!!
            if (mom.configOptions.replace)
                $(mom.configOptions.replaceElement).replaceWith(out);
            else
                $(mom.configOptions.target).html(out);
        }
    },

    setCacheByKey: function(cacheKey, content) {
        this.cache[ cacheKey ] = content;
    },
 
 	___: function() {}
};

var IV =
{
	debug:					1,
	assetsUrl: 				"//assets.",

// MODULES
	playlist:				IVPlayList,
	sys:					IVSystem,
	user:					IVUser,
	section:				IVSection,
	template:				IVTemplate,
	mainpage: 				IVMainPage,

// SYSTEM WIDE FUNCTIONS

	init: function()
	{
		var url = window.location.href.split("/")[2].split(".");
		var basePoint = $.inArray("indavideo",url);

		if ($.inArray("test", url) >= 0)
			this.assetsUrl += url[basePoint-2]+"."+url[basePoint-1]+"."+url[basePoint]+".hu/";
		else if ($.inArray("demo",url) >= 0)
			this.assetsUrl += url[basePoint-1]+"."+url[basePoint]+".hu/";
		else
			this.assetsUrl += url[basePoint]+".hu/";

		this.sys.init();
		this.playlist.init();
		this.user.init();
		this.section.init();
		this.template.init();
		this.mainpage.init();
	},

	jqDelSelectorPrefix: function(jqSelector)
	{
		return jqSelector.replace(/[\.#]*/g, "");
	},

	log: function(data)
	{
		if (IV.debug)
			console.log(data);
	},

    prevent : function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
    },

// THE LAST ONE - no more commas baby!

	__FLATLINE__: function(){}
};


;